import { render, staticRenderFns } from "./DetailSalesOrderApproval.vue?vue&type=template&id=43961f99&scoped=true&"
import script from "./DetailSalesOrderApproval.vue?vue&type=script&lang=js&"
export * from "./DetailSalesOrderApproval.vue?vue&type=script&lang=js&"
import style0 from "./DetailSalesOrderApproval.vue?vue&type=style&index=0&id=43961f99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43961f99",
  null
  
)

export default component.exports